module.exports = __webpack_public_path__ + "static/greeting-d3537b3483e9f542b0a7b18170917f2c.png";